function Square(letter, result){
    this.letter = letter
    this.result = result
}

export default Square